var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3,13.6c1.2-0.9,2.2-2.2,2.6-3.6c0.5-1.5,0.5-3,0-4.5c-0.5-1.5-1.4-2.7-2.6-3.6C15,1,13.5,0.5,12,0.5S9,1,7.7,1.9 C6.5,2.8,5.6,4.1,5.1,5.5c-0.5,1.5-0.5,3,0,4.5c0.5,1.5,1.4,2.7,2.6,3.6c-1.6,0.8-3,2-3.9,3.6c-1,1.5-1.5,3.3-1.5,5.1 c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4c0.2-0.2,0.4-0.5,0.4-0.9c0-1.9,0.8-3.8,2.1-5.1 S10.1,15,12,15s3.8,0.8,5.1,2.1c1.4,1.4,2.1,3.2,2.1,5.1c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4 c0.2-0.2,0.4-0.5,0.4-0.9c0-1.8-0.5-3.6-1.5-5.1C19.3,15.7,17.9,14.4,16.3,13.6z M7.2,7.8c0-1,0.3-1.9,0.8-2.7 c0.5-0.8,1.3-1.4,2.2-1.8C11,2.9,12,2.8,12.9,3c0.9,0.2,1.8,0.6,2.5,1.3c0.7,0.7,1.1,1.5,1.3,2.5c0.2,0.9,0.1,1.9-0.3,2.8 c-0.4,0.9-1,1.6-1.8,2.2c-0.8,0.5-1.7,0.8-2.7,0.8c-1.3,0-2.5-0.5-3.4-1.4C7.7,10.3,7.2,9.1,7.2,7.8z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.190451afda4d15e93519fb9b7394cae3.svg";
export { ForwardRef as ReactComponent };